import request from '@/utils/request'


export function addDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/addDistribution`,
        method: 'post',
        data,
    })
}

export function upDateDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/upDateDistribution`,
        method: 'post',
        data,
    })
}

export function DistributionSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/distribution/DistributionSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function bathDeleteDistribution(data) {
    return request({
        url: `api/serviceCenter/distribution/bathDeleteDistribution`,
        method: 'post',
        data,
    })
}






